import { z } from 'zod';
import { requiredDateInput } from '../zod-helpers/index.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
export const updateTransferOrderShipDateInputSchema = z.object({
    id: lowercasedRequiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    dateShipped: requiredDateInput('Ship date'),
});
//# sourceMappingURL=update-ship-date-input.js.map